interface AiSVGProps {
  color: string;
  style: React.CSSProperties;
}

const AiSVG = ({ color, style }: AiSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="51"
    viewBox="0 0 52 51"
    fill="none"
  >
    <g clipPath="url(#clip0_465_5966)">
      <path
        d="M2.51025 33.6802L6.61025 40.7802L7.96025 40.4502C10.7103 39.7702 13.6003 40.2402 16.0503 41.6602C16.0803 41.6802 16.1103 41.6902 16.1303 41.7102C18.6003 43.1302 20.4603 45.3902 21.2503 48.1302L21.6303 49.4602H29.8303L30.2103 48.1302C31.0003 45.4002 32.8603 43.1402 35.3203 41.7202C35.3303 41.7202 35.3403 41.7102 35.3603 41.7002C35.3703 41.7002 35.3803 41.6902 35.4003 41.6802C37.8603 40.2502 40.7503 39.7702 43.5103 40.4602L44.8603 40.7902L48.9603 33.6902"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.96 16.3401L44.86 9.24006L43.52 9.57006C40.77 10.2501 37.88 9.78006 35.43 8.36006C35.4 8.34006 35.37 8.33006 35.35 8.31006C32.88 6.89006 31.02 4.63006 30.23 1.89006L29.85 0.560059H21.65L21.27 1.89006C20.48 4.62006 18.62 6.88006 16.16 8.30006C16.15 8.30006 16.14 8.31006 16.12 8.32006C16.11 8.32006 16.1 8.33006 16.08 8.34006C13.62 9.77006 10.73 10.2501 7.97002 9.56006L6.62002 9.23006L2.52002 16.3301"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.5 25.0103H46.97"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4199 19.8901H43.8699"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4399 30.0903H43.7799"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9 25.0103C50.9 26.1003 50.02 26.9703 48.94 26.9703C47.86 26.9703 46.98 26.0903 46.98 25.0103C46.98 23.9303 47.86 23.0503 48.94 23.0503C50.02 23.0503 50.9 23.9303 50.9 25.0103Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.7999 19.8902C47.7999 20.9802 46.9199 21.8502 45.8399 21.8502C44.7599 21.8502 43.8799 20.9702 43.8799 19.8902C43.8799 18.8102 44.7599 17.9302 45.8399 17.9302C46.9199 17.9302 47.7999 18.8102 47.7999 19.8902Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.7999 30.0904C47.7999 31.1804 46.9199 32.0504 45.8399 32.0504C44.7599 32.0504 43.8799 31.1704 43.8799 30.0904C43.8799 29.0104 44.7599 28.1304 45.8399 28.1304C46.9199 28.1304 47.7999 29.0104 47.7999 30.0904Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9502 25.0103H4.49023"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0298 19.8901H7.58984"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0199 30.0903H7.66992"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.560059 25.0103C0.560059 26.1003 1.44006 26.9703 2.52006 26.9703C3.60006 26.9703 4.48006 26.0903 4.48006 25.0103C4.48006 23.9303 3.60006 23.0503 2.52006 23.0503C1.44006 23.0503 0.560059 23.9303 0.560059 25.0103Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66016 19.8902C3.66016 20.9802 4.54016 21.8502 5.62016 21.8502C6.70016 21.8502 7.58016 20.9702 7.58016 19.8902C7.58016 18.8102 6.70016 17.9302 5.62016 17.9302C4.54016 17.9302 3.66016 18.8102 3.66016 19.8902Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66016 30.0904C3.66016 31.1804 4.54016 32.0504 5.62016 32.0504C6.70016 32.0504 7.58016 31.1704 7.58016 30.0904C7.58016 29.0104 6.70016 28.1304 5.62016 28.1304C4.54016 28.1304 3.66016 29.0104 3.66016 30.0904Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0303 30.0898C16.8903 34.3098 20.9803 37.2498 25.7403 37.2498C30.4903 37.2498 34.5903 34.3198 36.4503 30.0898"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0502 19.8901C14.3602 21.4501 13.9702 23.1801 13.9702 25.0101"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.94 17.3803C32.78 14.5703 29.46 12.7603 25.73 12.7603C22 12.7603 18.68 14.5603 16.52 17.3803"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.4999 25.0101C37.4999 23.1801 37.1099 21.4501 36.4199 19.8901"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.53 30.0899L22.65 19.3599H24.18L28.57 30.0899H26.95L25.7 26.8399H21.21L20.03 30.0899H18.52H18.53ZM21.62 25.6899H25.26L24.14 22.7199C23.8 21.8199 23.54 21.0699 23.38 20.4899C23.24 21.1799 23.05 21.8599 22.8 22.5399L21.62 25.6899Z"
        fill={color}
      />
      <path
        d="M29.9502 30.0899V19.3599H31.3702V30.0899H29.9502Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_465_5966">
        <rect width="51.46" height="50.02" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default AiSVG;
